import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// This component will scroll to the top whenever the route changes.
const ScrollToTop = () => {
  const location = useLocation(); // Get current route location

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location]); // Dependency on location to trigger on route change

  return null;
};

export default ScrollToTop;
